import { SellerIntegrationType } from 'opensolar-common'
import { styled } from 'opensolar-ui'
import { FC, useEffect, useMemo, useRef } from 'react'
import ComponentBlock from './ComponentBlock'
import { ExpoLoggerType, StandData } from './expoStand'

const Container = styled('div', { name: 'Container' })({
  display: 'flex',
  maxWidth: 1440,
  margin: 'auto',
  minHeight: '100vh',
})
const PreviewWrapper = styled('div', { name: 'PreviewWrapper' })(({ theme }) => ({
  width: '100%',
  maxWidth: 1440,
  backgroundColor: theme.palette.neutralGrey[200],
  paddingBottom: 30,
}))
interface PropTypes extends StandData {
  clickLogger?: ExpoLoggerType
  enabledSellerIntegrations?: SellerIntegrationType[]
}

export const ExpoStandRenderer: FC<PropTypes> = (props) => {
  const { org, expoStand } = props
  const itemEls = useRef<any>({})
  const elements = expoStand?.contents?.elements
  const enabledContents = useMemo(() => elements?.filter((x) => x.enabled), [elements])

  useEffect(() => {
    const itemEl: HTMLDivElement = itemEls.current[window.location.hash.replace('#', '')]
    if (itemEl) itemEl.scrollIntoView()
  }, [window.location.hash])

  if (!org || !expoStand) return null
  return (
    <Container>
      <PreviewWrapper data-testid="expo-stand-wrapper">
        {!!enabledContents?.length && (
          <>
            {enabledContents.map((content) => (
              <div ref={(element) => (itemEls.current[content.contentType] = element)} key={content.contentType}>
                <ComponentBlock item={content} enabledContents={enabledContents} {...props} />
              </div>
            ))}
          </>
        )}
      </PreviewWrapper>
    </Container>
  )
}
